export const SET_PORTFOLIO_FILTER = 'SET_PORTFOLIO_FILTER';
export const SET_PORTFOLIO_LIST = 'SET_PORTFOLIO_LIST'
export const SET_PORTFOLIO_HELDAWAY_STATUS = 'SET_PORTFOLIO_HELDAWAY_STATUS'
export const SET_SELECTED_PORTFOLIO_OBJECT = "SET_SELECTED_PORTFOLIO_OBJECT"
export const STORE_BSE_TXN_STATUS = "STORE_BSE_TXN_STATUS"